import React, { createContext, useContext, useMemo } from 'react';

import { DEFAULT_STORY_DEFAULTS } from './StoryDefaultsProvider.constants';
import {
  TStoryDefaultsContextValue,
  TStoryDefaultsProviderProps,
} from './StoryDefaultsProvider.types';

const StoryDefaultsContext = createContext<TStoryDefaultsContextValue | null>(null);

export const useStoryDefaults = (): TStoryDefaultsContextValue => {
  const value = useContext(StoryDefaultsContext);
  if (!value) {
    throw new Error('useStoryDefaults must be used within a StoryDefaultsProvider');
  }
  return value;
};

const StoryDefaultsProvider = ({ children }: TStoryDefaultsProviderProps) => {
  const value = useMemo<TStoryDefaultsContextValue>(
    () => ({ defaults: DEFAULT_STORY_DEFAULTS }),
    []
  );

  return <StoryDefaultsContext.Provider value={value}>{children}</StoryDefaultsContext.Provider>;
};

export default StoryDefaultsProvider;
